import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Mi hija espera cada cita con ilusión. Nos acercó muchísimo.',
    author: 'María — mamá de 2 hijos',
    stars: 5
  }, {
    quote: 'Nos devolvió momentos que la rutina nos estaba robando.',
    author: 'Lucas — papá',
    stars: 5
  }, {
    quote: 'Ahora tengo actividades listas para compartir con mis hijos sin pensar.',
    author: 'Carolina — mamá',
    stars: 5
  }, {
    quote: 'No es un libro. Es tiempo de calidad real.',
    author: 'Andrea — mamá',
    stars: 5
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-249">
      <div className="max-w-3xl mx-auto" data-id="element-250">
        <div data-id="element-251">
          <div className="text-center mb-12" data-id="element-252">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-253">
              ⭐ LO QUE DICEN LOS PADRES
            </h2>
            <div className="flex justify-center gap-1 mb-4" data-id="element-254">
              {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-400 text-3xl" data-id="element-255">
                  ★
                </span>)}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-256">
            {testimonials.map((t, idx) => <div key={idx} className="bg-gray-50 p-6 rounded-xl border border-gray-200 shadow-md" data-id="element-257">
                <div className="flex gap-1 mb-3" data-id="element-258">
                  {[...Array(t.stars)].map((_, i) => <span key={i} className="text-yellow-400" data-id="element-259">
                      ★
                    </span>)}
                </div>
                <p className="text-gray-800 font-medium italic mb-3" data-id="element-260">
                  "{t.quote}"
                </p>
                <p className="text-sm text-gray-500 font-bold" data-id="element-261">— {t.author}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}